import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import './SpeedingBadges.css';

const SpeedingBadges = ({
  small = 0, medium = 0, large = 0, xlarge = 0, className
}) => (
  <div className={cn('speeding', className)} style={{ marginRight: 20 }}>
    <Badge zeroClassName="zeroSpeed" notzeroClassName="smallSpeed" value={small} />
    <Badge zeroClassName="zeroSpeed" notzeroClassName="mediumSpeed" value={medium} />
    <Badge zeroClassName="zeroSpeed" notzeroClassName="largeSpeed" value={large} />
    <Badge zeroClassName="zeroSpeed" notzeroClassName="xlargeSpeed" value={xlarge} />
  </div>
);
SpeedingBadges.propTypes = {
  small: PropTypes.number,
  medium: PropTypes.number,
  large: PropTypes.number,
  xlarge: PropTypes.number,
  className: PropTypes.string,
};

export default SpeedingBadges;

export const Badge = ({
  value = 0, zeroClassName = 'zero', notzeroClassName = 'notZero', onClick,
}) => (
  <div onClick={onClick} className={cn('sq-badge', { [zeroClassName]: value === 0, [notzeroClassName]: value !== 0 })}>{value}</div>
);

Badge.propTypes = {
  value: PropTypes.number,
  zeroClassName: PropTypes.string,
  notzeroClassName: PropTypes.string,
  onClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/SpeedingBadges.js